import React from 'react'
import { useTranslate, required } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useQuery } from 'react-query'

export const GetInstallmentFields = ({ record }) => {
  const translate = useTranslate()
  const { data, error, isError, isLoading } = useQuery('/gateway/all', businessRuleServices.getGateways)
  if (isError) {
    return (
      <div>
        {translate('ra.notification.http_error')} : {error.message}
      </div>
    )
  }
  return (
    <Grid container spacing={3}>
      <EditInputsWrap label={translate('ra.field.gateway')} required>
        {isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='payment_gateway'
            options={data}
            label=''
            optionsText={['name']}
            optionValue='value'
            size='small'
            multiple
            validate={[required()]}
            defaultValue={record ? record?.payment_gateway : undefined}
          />
        )}
      </EditInputsWrap>
    </Grid>
  )
}
